import { Component, OnInit } from '@angular/core'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { Store } from '@ngrx/store'
import { combineLatest, Observable } from 'rxjs'
import { filter, map, switchMap, tap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { participationActions } from '../../booking/participation/participation.actions'
import { participationSelectors } from '../../booking/participation/participation.selectors'
import { TemplateTypes } from '../../email-template/email-template'
import { Member } from '../../member/member'
import { memberSelectors } from '../../member/member.selectors'
import { Sale } from '../sale'
import { Participation } from '../../booking/participation/participation'
import { saleSelectors } from '../sale.selectors'

@Component({
  selector: 'sale-communication-tab',
  templateUrl: './communication-tab.component.html',
  styleUrls: ['./communication-tab.component.scss']
})
export class SaleCommunicationTabComponent implements OnInit {
  public saleId$: Observable<number>
  public saleSelectors = saleSelectors
  public templateTypes = TemplateTypes
  public loadSaleParticipations: (
    sale$: Observable<Sale>,
    store: Store<AppState>
  ) => Observable<Participation[]>
  public loadSaleSelectableMembers: (
    sale$: Observable<Sale>,
    store: Store<AppState>
  ) => Observable<Member[]>
  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.saleId$ = this.store.select(saleSelectors.selectIdRouteParam).pipe(
      filter((id) => Boolean(id)),
      map((saleId) => +saleId)
    )
    this.loadSaleParticipations = (
      sale$: Observable<Sale>,
      store: Store<AppState>
    ) =>
      sale$.pipe(
        tap((sale) => {
          if (sale?.saleItems?.length) {
            store.dispatch(
              participationActions.fetchMany({
                params: RequestQueryBuilder.create({
                  search: { saleItemId: { [CondOperator.IN]: sale.saleItems } },
                  join: [{ field: 'member' }, { field: 'invitedMember' }]
                })
              })
            )
          }
        }),
        switchMap((sale) =>
          store
            .select(participationSelectors.selectAll)
            .pipe(
              map((allParticipations) =>
                allParticipations.filter((participation) =>
                  sale?.saleItems?.includes(participation.saleItemId)
                )
              )
            )
        )
      )

    this.loadSaleSelectableMembers = (
      sale$: Observable<Sale>,
      store: Store<AppState>
    ) =>
      combineLatest([
        sale$,
        store.select(participationSelectors.selectAll),
        store.select(memberSelectors.selectEntities)
      ]).pipe(
        map(([sale, participations, memberEntities]) => {
          const participants = participations.filter((participation) =>
            sale?.saleItems?.includes(participation.saleItemId)
          )
          const members = [
            ...new Set(
              participants
                .map((participant) => participant.memberId)
                .filter((id) => id)
            )
          ]
            .map((memberId) => memberEntities[memberId])
            .filter((member) => member)
          const invitedMember = participants
            .map((participant) => participant.invitedMember)
            .filter((member) => member)

          return [...members, ...invitedMember]
        })
      )
  }
}
